export default __webpack_public_path__ + "static/media/close.f0f27634.svg";